import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { reportList } from './request';
export default {
  data() {
    return {
      policyNo: '',
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      data: [],
      columns: [
        // {title: '序号', dataIndex: 'index', key: '1',align: 'center',scopedSlots: {customRender: 'index'},width:80},
        // {title: '保单号', dataIndex: 'policyNo', key: '2',align: 'center'},
        // {title: '产品名称', dataIndex: 'insuranceName', key: '6',align: 'center'},
        // {title: '承保机构', dataIndex: 'agencyName', key: '3',align: 'center'},
        // {title: '保费', dataIndex: 'premium', key: '4',align: 'center'},
        // {title: '生效日期', dataIndex: 'startAt', key: '9',align: 'center'},
        // {title: '终止日期', dataIndex: 'endAt', key: '7',align: 'center'},
        // {title: '保单状态', dataIndex: 'status', key: '8',align: 'center',scopedSlots: {customRender: 'status'}},
        // {title: '操作', dataIndex: 'sort', key: '5',align: 'center',scopedSlots: {customRender: 'action'},width:100}
      ]
    };
  },
  created() {
    this.getDataFun();
  },
  methods: {
    searchFun() {
      this.pagination.current = 1;
      this.getDataFun();
    },
    async getDataFun() {
      const h = this.$createElement;
      const res = await reportList({
        pageSize: this.pagination.pageSize,
        page: this.pagination.current,
        policyNo: this.policyNo
      });
      console.log(res);
      if (res.fieldConfig) {
        this.columns = res.fieldConfig.map(item => {
          let obj = item;
          obj.slots = {
            title: item.title
          };
          delete obj.title;
          if (item.ellipsis) {
            obj.customRender = text => h("a-tooltip", {
              "attrs": {
                "placement": "topLeft",
                "title": text
              }
            }, [text]);
          }
          return obj;
        });
        this.columns.push({
          slots: {
            title: '操作'
          },
          dataIndex: 'sort',
          key: '5',
          align: 'center',
          scopedSlots: {
            customRender: 'action'
          },
          width: 100
        });
      }
      this.data = res.items;
      this.pagination.total = res.totalNum;
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    }
  }
};